import React from "react";
import { Stepper, Step, StepLabel, Typography } from "@mui/material";

/**
 * A reusable stepper component with customizable properties
 * 
 * @param {Object} props - Component props
 * @param {number} props.activeStep - Current active step (1-based index)
 * @param {Array} props.steps - Array of step labels
 * @param {boolean} props.isMobile - Whether the device is mobile or not
 * @param {Object} props.theme - Theme object
 * @param {Object} props.sx - Additional styles for Stepper component
 */
const CStepper = ({
  activeStep,
  steps = ["Upload File", "Process Data", "Download Results"],
  isMobile,
  theme,
  sx = {},
}) => {
  return (
    <Stepper
      activeStep={activeStep - 1} // Convert 1-based index to 0-based index
      alternativeLabel={!isMobile}
      orientation={isMobile ? "vertical" : "horizontal"}
      sx={{ mb: 4, ...sx }}
    >
      {steps.map((step, index) => (
        <Step key={index}>
          <StepLabel 
            StepIconProps={{
              sx: {
                "&.Mui-completed": { color: theme.palette.secondary.main }, // Completed steps green
                "&.Mui-active": { color: theme.palette.primary.main },      // Active step blue
                color: "#CCCCCC",                                           // Default gray
              }
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                color: activeStep === index + 1 ? "primary.main" : 
                      (activeStep > index + 1 ? "secondary.main" : "inherit"),
                fontWeight: activeStep === index + 1 ? "bold" : "normal",
              }}
            >
              {step}
            </Typography>
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default CStepper;